export default "__VITE_ASSET__CDVhFg12__"